import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { systemPills } from '../data/content';
export function SystemSection() {
  return <section className="w-full bg-slate-950 px-5 py-12 text-white sm:py-14" data-id="element-204" data-mp="3girex8kh47xr">
      <div className="mx-auto max-w-[1000px] text-center" data-id="element-205" data-mp="3bhllt9mwiinp">
        <h2 className="text-balance text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight sm:text-[2.1rem]" data-id="element-206" data-mp="36k27k9q7e5vr">
          The Complete 6-in-1 Financial Literacy Teaching System
        </h2>

        <p className="mt-3 flex items-center justify-center gap-2 text-[1.2rem] font-extrabold uppercase leading-[0.95] tracking-tight text-orange-500 sm:text-[1.4rem]" data-id="element-207" data-mp="2wu8wd9tz3ss1">
          <ZapIcon className="h-5 w-5 fill-orange-500" aria-hidden="true" data-id="element-208" data-mp="2sqau4q9cq1ur" />
          Financial Literacy Ready™
        </p>

        <p className="mt-3 text-[0.8rem] font-bold uppercase tracking-[0.22em] text-white/80 sm:text-[0.9rem]" data-id="element-209" data-mp="2ity6a90hmi7x">
          Plan • Teach • Practice • Apply • Assess • Track
        </p>

        <ul className="mx-auto mt-7 grid gap-3 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-210" data-mp="2dxh8en3hkphn">
          {systemPills.map(pill => <li key={pill} className="flex items-center gap-3 rounded-md bg-slate-900 px-5 py-3.5 text-[1rem] text-white" data-id="element-211" data-mp="18q6gyhwrc0xe">
              <CheckIcon className="h-4 w-4 shrink-0 text-orange-500" strokeWidth={2.5} aria-hidden="true" data-id="element-212" data-mp="tz7c9hz1lwj3" />
              {pill}
            </li>)}
        </ul>
      </div>
    </section>;
}